import { initBenefitsSlider } from './modules/benefits-slider.js';
import { initFaq } from './modules/faq.js';

const header = document.querySelector(".header");
const menuToggle = header?.querySelector(".header__menu-toggle");
const nav = header?.querySelector(".header__nav");

if (menuToggle && nav) {
  menuToggle.addEventListener("click", () => {
    const expanded = menuToggle.getAttribute("aria-expanded") === "true";
    menuToggle.setAttribute("aria-expanded", String(!expanded));
    nav.hidden = expanded;
  });

  nav.hidden = true;
}

document.querySelectorAll("a[href^='#']").forEach(link => {
  link.addEventListener("click", event => {
    const targetId = link.getAttribute("href")?.substring(1);
    const target = targetId ? document.getElementById(targetId) : null;

    if (target) {
      event.preventDefault();
      target.scrollIntoView({ behavior: "smooth" });
    }
  });
});

// Инициализация слайдера
document.addEventListener('DOMContentLoaded', () => {
  initBenefitsSlider();
  initFaq();
});
